<template>
  <v-app>
    <v-app-bar
      app
      color="primary"
      dark
    >
      <snackbar></snackbar>
      <router-link :to="{name: 'home'}" class="d-flex align-center">
        <v-icon x-large class="mr-5">mdi-tennis</v-icon>
        <h1 class="white--text">Tennispoule</h1>
      </router-link>

      <v-spacer></v-spacer>

      <div v-for="item in items" v-bind:key="item.name" class="d-flex align-center">
        <router-link class="white--text pl-8" :to="{name: item.name}"><v-icon>{{ item.icon }}</v-icon>{{item.title}}</router-link>
      </div>

      <v-spacer></v-spacer>

      <file-upload></file-upload>

      <v-btn href="https://jovisst.nl" target="_blank" text>
        <span class="mr-2">Meer info</span>
        <v-icon>mdi-open-in-new</v-icon>
      </v-btn>
      <settings-button :options="settingsOptions" v-on:chosen="handleSettingsChoice" button-color="white"></settings-button>

    </v-app-bar>

    <v-content>
      <router-view/>
    </v-content>
  </v-app>
</template>

<script>

import FileUpload from './components/FileUpload';
import Snackbar from './components/Snackbar';
import SettingsButton from './components/SettingsButton';

export default {
  name: 'App',

  components: {
    SettingsButton,
    Snackbar,
    FileUpload
  },

  data () {
    return {
      items: [
        { name: 'participants', title: 'Deelnemers', icon: 'mdi-account-multiple' },
        { name: 'poules', title: 'Poules', icon: 'mdi-folder-multiple' },
        { name: 'courts', title: 'Banen', icon: 'mdi-table-column-width' },
      ],
      right: null,
      settingsOptions: [
        { title: 'Opslaan', method: 'save', icon: 'mdi-file-download' },
        { title: 'Verwijder alles', method: 'clearStorage', icon: 'mdi-delete' }
      ]
    };
  },

  methods: {
    handleSettingsChoice: function (value) {
      switch (value) {
        case 'save':
          this.$store.commit('SAVE_STORE');
          this.$store.commit('entities/participants/SET_SUCCESS', 'Alle gegevens zijn opgeslagen op een file op je eigen computer.');
          break;
        case 'clearStorage':
          if (confirm('Alles verwijderen? Weet je het zeker?') === true) {
            this.$store.dispatch('entities/deleteAll');
            this.$store.commit('entities/participants/SET_SUCCESS', 'Alle gegevens zijn verwijderd.');
          }
          break;
        case 'x':
          break;
      };
    }
  }
}
</script>
